var _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocxFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 52,
    viewBox: "0 0 38 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.26 43.4717H5.98576C5.48863 43.469 4.99747 43.369 4.54328 43.1778C4.08909 42.9866 3.68174 42.7084 3.34694 42.3607C2.63169 41.6331 2.23776 40.6742 2.2459 39.6807L2 8.56116L5.83896 5.39506L11.1753 1H30.26C30.7571 1.00261 31.2483 1.10268 31.7025 1.29389C32.1567 1.4851 32.564 1.76329 32.8988 2.11091C33.6141 2.83857 34.008 3.79744 33.9999 4.791V39.6807C34.008 40.6742 33.6141 41.6331 32.8988 42.3607C32.564 42.7084 32.1567 42.9866 31.7025 43.1778C31.2483 43.369 30.7571 43.469 30.26 43.4717ZM11.1753 1.4652L2 8.56116L11.4763 8.76599L11.1937 1.47561L11.1753 1.4652Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.56116L2.2459 39.6807C2.23776 40.6742 2.63169 41.6331 3.34694 42.3607C3.68174 42.7084 4.08909 42.9866 4.54328 43.1778C4.99747 43.369 5.48863 43.469 5.98576 43.4717H30.26C30.7571 43.469 31.2483 43.369 31.7025 43.1778C32.1567 42.9866 32.564 42.7084 32.8988 42.3607C33.6141 41.6331 34.008 40.6742 33.9999 39.6807V4.791C34.008 3.79744 33.6141 2.83857 32.8988 2.11091C32.564 1.76329 32.1567 1.4851 31.7025 1.29389C31.2483 1.10268 30.7571 1.00261 30.26 1H11.1753L5.83896 5.39506L2 8.56116ZM2 8.56116L11.1753 1.4652L11.1937 1.47561L11.4763 8.76599L2 8.56116Z",
    stroke: "#747272",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.97363 15.6094L29.6573 15.5507",
    stroke: "#747272",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.97363 21.9248H29.6917",
    stroke: "#747272",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.97363 28.2393H29.6917",
    stroke: "#747272",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.97363 34.5537H29.6917",
    stroke: "#747272",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 41,
    r: 11,
    fill: "#005FBF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3838 43.6328L26.4824 39.7168H27.376L27.0879 41.2549L25.9893 45H25.2422L25.3838 43.6328ZM24.8271 39.7168L25.6133 43.6279L25.6865 45H24.8076L23.4697 39.7168H24.8271ZM28.3818 43.5645L29.1484 39.7168H30.5107L29.1729 45H28.2988L28.3818 43.5645ZM27.498 39.7168L28.5918 43.6035L28.7432 45H27.9912L26.8926 41.2598L26.6143 39.7168H27.498Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocxFile);
export default __webpack_public_path__ + "static/media/docx-file.8d79e567760d4249c748e52c734d9849.svg";
export { ForwardRef as ReactComponent };